import { SET_PAGE_VIEW_ID } from 'apps/analytics/actions/analytics';

export const initialState = {
  pageView: {},
};

export default function analytics(state = initialState, action) {
  switch (action.type) {
    case SET_PAGE_VIEW_ID: {
      const { id, url } = action;
      return {
        pageView: { id, url },
      };
    }
    default:
      return state;
  }
}
